<template>
  <div>
    <ul
      class="selector inline time mt10 with-custom"
      :class="element_settings.style_class"
    >
      <li v-for="(option, index) in element_settings.options" :key="index">
        <input
          type="radio"
          :id="
            'duration-' + element_settings.name + '-' + option.value + '-min'
          "
          :name="element_settings.name"
          :value="option.value"
          v-model="form[element_settings.name]"
          @change="load_custom_value"
        />
        <label
          :for="
            'duration-' + element_settings.name + '-' + option.value + '-min'
          "
        >
          {{ option.text }}
          <span>{{ T__("min") }}</span>
        </label>
      </li>

      <li class="custom-duration" v-if="element_settings.custom_option">
        <input
          type="radio"
          :name="element_settings.name"
          :checked="custom_checked"
        />
        <label :for="'custom-duration--' + element_settings.name + ''">
          <input
            type="number"
            :id="'custom-duration--' + element_settings.name + ''"
            :placeholder="custom_value_focus === true ? '' : '-'"
            :value="get_custom_value"
            @focus="custom_value_on_focus"
            @blur="
              custom_value_focus = false;
              $v && $v.form[element_settings.name]
                ? $v.form[element_settings.name].$touch()
                : '';
            "
            @input="debounce_set_custom_value"
          />
          <span>{{ T__("custom min") }}</span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
import { findIndex, debounce } from "lodash-es";
export default {
  name: "InlineRadioSelector",
  props: {
    element_settings: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    $v: {}
  },
  data() {
    return {
      custom_value: "",
      custom_value_focus: false
    };
  },
  computed: {
    get_custom_value() {
      return isNaN(this.custom_value) ? "" : this.custom_value;
    },
    custom_checked() {
      return this.custom_value !== "" ? true : false;
    }
  },
  methods: {
    set_custom_value($event) {
      this.custom_value = parseInt($event.target.value);
      this.form[this.element_settings.name] = this.custom_value;
      this.load_custom_value();
    },
    debounce_set_custom_value: debounce(function($event) {
      this.set_custom_value($event);
    }, 500),
    custom_value_on_focus($event) {
      this.custom_value_focus = true;
      this.set_custom_value($event);
    },
    load_custom_value() {
      if (
        findIndex(this.element_settings.options, {
          value: parseInt(this.form[this.element_settings.name])
        }) == -1
      ) {
        this.custom_value = this.form[this.element_settings.name];
      } else {
        this.custom_value = "";
      }
    }
  },
  created() {
    this.load_custom_value();
  }
};
</script>

<style lang="css" scoped>
input[id^="custom-duration--"] {
  width: 50px !important;
  height: 22px;
  padding: 0 !important;
  margin: 0;
  min-height: unset;
  border: 0 !important;
  text-align: center;
  background: transparent;
}
</style>
